
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/athlete/view_competition_results.css.ts.vanilla.css\",\"source\":\"Ll8xc2dubWljMDpob3ZlciB7CiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tXzFqN3JwNTcxcik7Cn0KLl8xc2dubWljMSB7CiAgd2lkdGg6IDk2cHg7Cn0KLl8xc2dubWljMiB7CiAgd2lkdGg6IDMwMHB4Owp9Ci5fMXNnbm1pYzMgewogIHdpZHRoOiAxNDBweDsKfQouXzFzZ25taWM0IHsKICB3aWR0aDogMjAwcHg7Cn0KLl8xc2dubWljNSB7CiAgd2lkdGg6IDcwcHg7Cn0KLl8xc2dubWljNiB7CiAgd2lkdGg6IDk2cHg7Cn0KLl8xc2dubWljNyB7CiAgZmxleDogMSAwIDIwMHB4Owp9\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/athlete/view_competition_results.css.ts.vanilla.css\",\"source\":\"Ll8xc2dubWljMDpob3ZlciB7CiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tXzFqN3JwNTcxcik7Cn0KLl8xc2dubWljMSB7CiAgd2lkdGg6IDk2cHg7Cn0KLl8xc2dubWljMiB7CiAgd2lkdGg6IDMwMHB4Owp9Ci5fMXNnbm1pYzMgewogIHdpZHRoOiAxNDBweDsKfQouXzFzZ25taWM0IHsKICB3aWR0aDogMjAwcHg7Cn0KLl8xc2dubWljNSB7CiAgd2lkdGg6IDcwcHg7Cn0KLl8xc2dubWljNiB7CiAgd2lkdGg6IDk2cHg7Cn0KLl8xc2dubWljNyB7CiAgZmxleDogMSAwIDIwMHB4Owp9\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
